import WorkspacePreview from './WorkspacePreview';
export default WorkspacePreview;
